module.exports = __webpack_public_path__ + "static/img/quanqin@2x.ecbb2b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/quanqin@2x.png
// module id = Gpwe
// module chunks = 1